import * as yup from 'yup';

import { parseAddonValuesText } from './_utils';
import { EdgeLocationAddonName, EdgeLocationFormValues } from './types';
import { EDGE_LOCATION_ADDON_NAME_TO_DISPLAY_NAME_MAP } from './constants';

const formModelAddonSchema = yup.object({
  enabled: yup.boolean(),
  values: yup.string().when('enabled', {
    is: true,
    then: (schema) =>
      schema.test(
        'json-object',
        'Helm values must be a valid JSON object',
        (addonValuesText) =>
          parseAddonValuesText(addonValuesText).type === 'success'
      ),
  }),
});

// Addon names are only known at runtime (they come from the API), so the
// object shape is built from the current form value
export const formModelAddonsSchema = yup.lazy(
  (addons: EdgeLocationFormValues['addons'] | undefined) =>
    yup
      .object(
        Object.fromEntries(
          Object.keys(addons || {}).map((addonName) => [
            addonName,
            formModelAddonSchema,
          ])
        )
      )
      .test('dra-requires-gpu-operator', function (addonFormValues) {
        const isDraEnabled =
          !!addonFormValues?.[EdgeLocationAddonName.NvidiaDra]?.enabled;
        const isGpuOperatorEnabled =
          !!addonFormValues?.[EdgeLocationAddonName.NvidiaGpuOperator]?.enabled;
        const draEnabledPath = `${this.path}.${EdgeLocationAddonName.NvidiaDra}.enabled`;

        return (
          !isDraEnabled ||
          isGpuOperatorEnabled ||
          this.createError({
            path: draEnabledPath,
            message: `Requires the ${
              EDGE_LOCATION_ADDON_NAME_TO_DISPLAY_NAME_MAP[
                EdgeLocationAddonName.NvidiaGpuOperator
              ]
            } add-on to be enabled`,
          })
        );
      })
);
